import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
interface NewsItem {
  date: string;
  tag: string;
  headline: string;
  source: string;
  blurb: string;
}
const news: NewsItem[] = [{
  date: '2026',
  tag: 'RESEARCH',
  headline: '2026 Gartner Magic Quadrant for Developer Productivity Insight Platforms published',
  source: 'GARTNER',
  blurb: 'The category is formally recognized as DPIP, with vendors evaluated on engineering metrics, developer experience, AI measurement, and business alignment.'
}, {
  date: '2026',
  tag: 'TREND',
  headline: 'AI impact, ROI, and adoption become standard engineering KPIs in 2026',
  source: 'INDUSTRY',
  blurb: 'Engineering orgs move from experimenting with coding assistants to measuring them — attribution, return, and real adoption are now reported to the board.'
}, {
  date: '2026',
  tag: 'REPORT',
  headline: 'DORA guidance evolves to account for AI-assisted software delivery',
  source: 'DORA',
  blurb: 'Latest research examines how AI tooling affects throughput and stability, cautioning that adoption without measurement can erode delivery quality.'
}, {
  date: '2026',
  tag: 'PRODUCT',
  headline: 'Waydev expands its AI suite with Impact, ROI, and Adoption modules',
  source: 'WAYDEV BLOG',
  blurb: 'Building on its AI ROI Calculator, Waydev rolls out dedicated modules to quantify the impact, return, and adoption of AI across engineering teams.'
}, {
  date: '2025-11-14',
  tag: 'PRODUCT',
  headline: 'New: Developer Experience (DX) through surveys ingested in Waydev',
  source: 'WAYDEV BLOG',
  blurb: 'Waydev adds developer experience surveys directly into the platform, blending qualitative DevEx signals with its existing system metrics.'
}, {
  date: '2025',
  tag: 'RECOGNITION',
  headline: 'Waydev named a Market Leader in Software Engineering Intelligence',
  source: 'G2 CROWD',
  blurb: 'G2 recognizes Waydev as a market leader across its Winter, Summer, and Spring 2025 reports for the software engineering intelligence category.'
}, {
  date: '2025',
  tag: 'TOOL',
  headline: 'Waydev launches the AI ROI Calculator for engineering leaders',
  source: 'WAYDEV',
  blurb: 'A dedicated calculator helps teams quantify the return on AI coding tools, tying assistant spend to measurable engineering output.'
}, {
  date: '2025',
  tag: 'INSIGHT',
  headline: 'Measuring AI impact and adoption becomes a board-level priority',
  source: 'WAYDEV BLOG',
  blurb: 'As AI coding assistants scale, engineering leaders look to platforms that can attribute impact, prove ROI, and track real adoption across teams.'
}, {
  date: '2025',
  tag: 'CATEGORY',
  headline: 'Engineering intelligence consolidates around DORA, SPACE, and DevEx',
  source: 'INDUSTRY',
  blurb: 'The category continues to mature as buyers favor platforms that combine delivery metrics, developer experience, and business alignment in one place.'
}];
export function NewsSection() {
  return <section id="news" className="py-24 bg-base relative hairline-t" data-id="element-255">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8 relative z-10" data-id="element-256">
        <div className="mb-16 font-mono" data-id="element-257">
          <div className="text-lime text-xs tracking-widest mb-4 flex items-center gap-3" data-id="element-258">
            <span className="w-2 h-2 bg-lime animate-pulse-fast" data-id="element-259" />
            §05 / DISPATCH WIRE
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink uppercase tracking-tight mb-6" data-id="element-260">
            Signal Intel
          </h2>
          <p className="text-ink/60 text-sm max-w-2xl leading-relaxed hairline-l pl-6 border-ink/20" data-id="element-261">
            Live transmissions from the developer productivity and engineering
            intelligence space — funding, research, and category moves.
          </p>
        </div>

        <ul className="hairline-t" data-id="element-262">
          {news.map((item, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05,
          ease: 'easeOut'
        }} className="hairline-b group" data-id="element-263">
              <a href="#" className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-baseline py-6 px-4 -mx-4 hover:bg-ink/5 transition-colors" data-id="element-264">
                <div className="md:col-span-2 font-mono text-[11px] tracking-widest text-ink/40" data-id="element-265">
                  <time dateTime={item.date} data-id="element-266">{item.date}</time>
                </div>
                <div className="md:col-span-2 font-mono text-[10px] tracking-widest" data-id="element-267">
                  <span className="bg-lime/10 text-lime px-2 py-1 border border-lime/30" data-id="element-268">
                    {item.tag}
                  </span>
                </div>
                <div className="md:col-span-8" data-id="element-269">
                  <h3 className="font-display text-lg md:text-xl font-bold text-ink leading-snug group-hover:text-lime transition-colors flex items-start gap-2" data-id="element-270">
                    <span data-id="element-271">{item.headline}</span>
                    <ArrowUpRight className="w-4 h-4 mt-1 shrink-0 text-ink/30 group-hover:text-lime transition-colors" data-id="element-272" />
                  </h3>
                  <p className="font-mono text-xs text-ink/55 leading-relaxed mt-2 max-w-2xl" data-id="element-273">
                    {item.blurb}
                  </p>
                  <div className="font-mono text-[10px] tracking-widest text-ink/35 mt-3" data-id="element-274">
                    SRC: {item.source}
                  </div>
                </div>
              </a>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}